export const hasPermission = (perm) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const permissions = user?.role?.permissions;

    if (!Array.isArray(permissions)) return false;
    if (permissions.includes("*")) return true;

    return permissions.includes(perm);
  } catch {
    return false;
  }
};
